import React, { useEffect, useState } from "react";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { Link, useNavigate, useParams } from "react-router-dom";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  updatingLinkCard,
  resetCardLink,
} from "../../../../../redux/slices/cards/cardSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import { toast } from "react-hot-toast";
import LinkForm from "../forms/LinkForm";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";

import useFetchBlock from "../../../../../hooks/useFetchBlock";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";
import SpinnerGiff from "../../../../../assets/spinner.svg";

const EditLink = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const { setActiveMainPageNav } = useStateContext();
  const [subLoading, setSubLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { themeDirection } = useSettings();
  const { optionId } = useParams();
  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [prevData, setPrevData] = useState(null);
  const userID = JSON.parse(localStorage.getItem("user")).userid;
  const url = baseUrl + "/api/user/getOption/" + userID + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    setPrevData({ ...data?.data });
    if (error) {
      toast.error("Something went wrong...");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  // handling heading api reponses messages
  const {
    updatedLinkCard,
    linkCardError,
    linkCardSuccess,
    linkCardLoading,
    linkCardErrorMsg,
  } = useSelector((state) => state?.cards?.linkCard);
  // console.log(
  //   useSelector((state) => state?.cards?.linkCard),
  //   "useSelector((state) => state?.cards?.linkCard)"
  // );
  useEffect(() => {
    if (updatedLinkCard?.status === "success" && linkCardSuccess) {
      toast.success(updatedLinkCard?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (updatedLinkCard?.status === "failed" && linkCardSuccess) {
      toast.error(updatedLinkCard?.message);
    }
    if (linkCardError) {
      toast.error(linkCardErrorMsg);
    }
    dispatch(resetCardLink());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkCardLoading, updatedLinkCard]);

  const linkId = localStorage.getItem("linkId");
  const submitHandlerParent = async (data) => {
    setSubLoading(true);
    const formData = {};
    formData.optionId = optionId;
    formData.coloum_type = data?.coloumnType;
    if (!/^(http|https):\/\//i.test(data.coloumnValue)) {
      formData.coloum_value = "https://" + data.coloumnValue;
    } else {
      formData.coloum_value = data?.coloumnValue;
    }
    formData.linkId = linkId;
    formData.coloum_name = "link";
    formData.prevIcon = data.prevIcon ? "1" : "0";
    if (data?.linkIcon) {
      formData.picture = data.linkIcon;
    }
    formData.language = prevData?.language
    await dispatch(updatingLinkCard(formData));
    setSubLoading(false);
  };

  const fetchingLinksList = () => {
    //  _______data needed for linklist api
    const user = JSON.parse(localStorage.getItem("user"));

    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };

    dispatch(gettingLinkList(linkListData));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  //  delete block api response state handler
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      navigate("/500");
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={prevData?.language}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div className="text-2xl font-semibold">
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="pt-1 dark:text-color_v1_dark">
              {translate("edit_taxes.edit")} {translate("link")}{" "}
            </p>
          </div>
        </Link>
      </div>
      <LinkForm
        formType={"edit"}
        submitHandlerParent={submitHandlerParent}
        deleteHandler={() => setIsModalOpen(true)}
        isLoading={subLoading}
        prevData={prevData}
      />
    </>
  );
};

export default EditLink;
